"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorRender = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./styles.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ErrorRender = function ErrorRender(_ref) {
  var _ref$reloadIconColor = _ref.reloadIconColor,
      reloadIconColor = _ref$reloadIconColor === void 0 ? "gray" : _ref$reloadIconColor,
      _ref$handleRetry = _ref.handleRetry,
      handleRetry = _ref$handleRetry === void 0 ? function () {} : _ref$handleRetry,
      Icon = _ref.icon,
      height = _ref.height,
      width = _ref.width;
  var handler = (0, _react.useRef)();

  var _handleRetry = (0, _react.useCallback)(function () {
    clearTimeout(handler.current);
    handler.current = setTimeout(handleRetry, 300);
  }, [handleRetry]);

  if (Icon) return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: _handleRetry
  }, Icon);
  return /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: reloadIconColor,
      fontSize: width < height ? height / 2 < 50 ? height / 2 : 50 : width / 2 < 50 ? width / 2 : 50
    },
    onClick: _handleRetry,
    className: "assetcrush-reload"
  }, "\u21BB");
};

exports.ErrorRender = ErrorRender;